import { axiosInstance } from '../api';

export default function(studyId) {
    return axiosInstance.get(`/api/studyreview/status/${studyId}`);
}